import React, { useContext, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { AuthContext } from "../../../../contexts/AuthContext";
import * as links from "../../../../utils/links";
import "./MainSidebar.css";

const Sidebar = (props) => {
  const {
    toggleDrawerClose
  } = props

  const [isOpen, setIsOpen] = useState(true);
  const location = useLocation();
  const { setDataUser, loading, authInfo } = useContext(AuthContext);
  let navigate = useNavigate();
  const { dataUser } = authInfo;

  return (
    <div style={{ display: 'flex' }}>
      <aside className={`sidebar ${isOpen ? "open" : ""}`}>
        <div className="inner">
          <div className="header">
            <img src="/logo.svg" alt="Logo" className="logo" />
            <h1 className={`header-title ${isOpen ? "open" : ""}`}>Zeus Pix</h1>
          </div>
          <div className="user-card">
            <i class="bi bi-person-circle"></i>
            <span className={`user-name ${isOpen ? "open" : ""}`}>{dataUser?.name}</span>
          </div>
          <nav className="menu">
            {
              dataUser?.key === "CLIENT"
                ?
                <button
                  className={location.pathname === links.DASHBOARD_FORNECEDOR ? "active" : ""} type="button" onClick={() => {
                    navigate(
                      links.DASHBOARD_FORNECEDOR
                    );
                    toggleDrawerClose();
                  }}>
                  <i class="bi bi-hdd-stack large-icon"></i>
                  <span>Máquinas</span>
                </button>
                :
                <button className={location.pathname === links.DASHBOARD_CLIENTES ? "active" : ""} type="button" onClick={() => {
                  navigate(
                    links.DASHBOARD_CLIENTES
                  );
                  toggleDrawerClose();
                }}>
                  <i class="bi bi-people large-icon"></i>
                  <span>Clientes</span>
                </button>
            }
            {
              dataUser?.key === "ADMIN" && dataUser?.email !== 'daniel@zeuspix.com.br' ?
                <button className={location.pathname === links.LISTA_MAQUINAS ? "active" : ""} type="button" onClick={() => {
                  navigate(
                    links.LISTA_MAQUINAS
                  );
                  toggleDrawerClose();
                }}>
                  <i class="bi bi-hdd-stack large-icon"></i>
                  <span>Máquinas</span>
                </button>
                :
                ''
            }
            {
              dataUser?.key === "ADMIN" && dataUser?.email !== 'daniel@zeuspix.com.br' ?
                <button className={location.pathname === links.MENSALIDADES_ADM_LIST ? "active" : ""} type="button" onClick={() => {
                  navigate(
                    links.MENSALIDADES_ADM_LIST
                  );
                  toggleDrawerClose();
                }}>
                  <i class="bi bi-qr-code large-icon"></i>
                  <span>Mensalidades</span>
                </button>
                :
                ''
            }
            {
              dataUser?.key === "CLIENT" ?
                <button className={location.pathname === links.NEW_PASSWORD ? "active" : ""} type="button" onClick={() => {
                  navigate(
                    links.NEW_PASSWORD
                  );
                  toggleDrawerClose();
                }}>
                  <i class="bi bi-key large-icon"></i>
                  <span>Trocar Senha</span>
                </button>
                :
                ''
            }
            {
              dataUser?.key === "CLIENT" ?
                <button className={location.pathname === links.CLIENTE_PAGAMENTOS ? "active" : ""} type="button" onClick={() => {
                  navigate(
                    links.CLIENTE_PAGAMENTOS
                  );
                  toggleDrawerClose();
                }}>
                  <i class="bi bi-credit-card-2-front large-icon"></i>
                  <span>Pagamentos</span>
                </button>
                :
                ''
            }
            {
              dataUser?.key === "CLIENT" ?
                <button className={location.pathname === links.CLIENTE_MENSALIDADES ? "active" : ""} type="button" onClick={() => {
                  navigate(
                    links.CLIENTE_MENSALIDADES
                  );
                  toggleDrawerClose();
                }}>
                  <i class="bi bi-qr-code large-icon"></i>
                  <span style={{ flexWrap: 'wrap' }}>Mensalidades</span>
                </button>
                :
                ''
            }
            <button type="button" onClick={() => {
              navigate(
                dataUser?.key === "CLIENT" ? links.SIGNIN : links.ADMIN_SIGNIN
              );
              setDataUser(null);
              toggleDrawerClose();
            }}>
              <i class="bi bi-escape large-icon"></i>
              <span>Sair</span>
            </button>
          </nav>
        </div>
      </aside>
    </div>
  );
};

export default Sidebar;
